import React, { memo, useCallback, useEffect, useState } from "react";
import { compactFormat } from "../../Functions/formatNumber";
import { IoRefresh } from "react-icons/io5";
import { getAgentPanelData } from "../../apis";

function PanelSumarry() {
  const [summaryData, setSummaryData] = useState(null);
  const [loading, setLoading] = useState(false);

  const getPanelSummary = useCallback(async () => {
    setLoading(true);
    let res = await getAgentPanelData();
    if (res.success) {
      setSummaryData(res.data);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    getPanelSummary();
  }, []);

  return (
    <div className="calls-info">
      <div className="row">
        <div className="col-11 col-lg-5 col-xl-6 cl-left ">
          <div className="col-left listing-row ">
            <div className="item-list first-icon">
              <svg width="40" height="40" viewBox="0 0 231 232" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M71.9826 14.1745C68.8133 11.442 64.7632 9.95963 60.5875 10.0008L60.5382 10.0011H27.2051C24.8166 10.0037 22.4544 10.5046 20.2688 11.4725C18.0824 12.4407 16.1201 13.8551 14.5072 15.6264C12.8943 17.3978 11.6664 19.4871 10.9022 21.7619C10.1419 24.025 9.85739 26.4217 10.0667 28.8007C13.6366 62.4407 25.057 94.7647 43.403 123.156L43.4266 123.193C60.0945 149.49 82.3325 171.784 108.561 188.493L108.6 188.518C136.787 206.844 168.867 218.288 202.263 221.934C204.636 222.143 207.027 221.856 209.284 221.09C211.555 220.321 213.641 219.083 215.409 217.457C217.177 215.831 218.587 213.853 219.549 211.647C220.511 209.441 221.003 207.058 220.993 204.65L220.993 204.63V171.21C220.993 171.168 220.994 171.127 220.995 171.086C221.1 166.845 219.646 162.715 216.913 159.482C214.185 156.254 210.373 154.144 206.2 153.549C195.166 152.088 184.332 149.381 173.905 145.481L173.893 145.476C170.813 144.315 167.465 144.064 164.247 144.752C161.033 145.439 158.081 147.035 155.74 149.352C155.737 149.355 155.734 149.358 155.731 149.361L141.639 163.489C140.046 165.086 137.582 165.419 135.622 164.302C107.021 147.997 83.3403 124.256 67.0786 95.5851C65.9703 93.6311 66.3013 91.1778 67.8877 89.5873L81.98 75.4594C81.9829 75.4565 81.9858 75.4536 81.9886 75.4507C84.3003 73.1037 85.8949 70.1408 86.5819 66.9114C87.2697 63.678 87.0185 60.3147 85.8584 57.2206L85.8542 57.2094C81.9639 46.7574 79.2646 35.8983 77.8078 24.8387C77.2179 20.6917 75.1469 16.9026 71.9826 14.1745ZM60.5147 0.00108051C67.1151 -0.0577598 73.5107 2.28836 78.5125 6.60078C83.5205 10.9186 86.7892 16.9124 87.7128 23.4638L87.7191 23.5097C89.0769 33.8307 91.5948 43.9644 95.2247 53.7176C97.0521 58.5959 97.447 63.8964 96.363 68.9922C95.2784 74.0908 92.7582 78.7724 89.0995 82.4818L89.0798 82.5016L77.6826 93.9277C92.3252 118.478 112.804 139.011 137.287 153.692L148.671 142.279L148.69 142.26C152.391 138.591 157.064 136.062 162.156 134.973C167.246 133.885 172.541 134.282 177.413 136.116C187.139 139.754 197.245 142.278 207.536 143.639L207.581 143.645C214.197 144.58 220.236 147.921 224.551 153.027C228.852 158.116 231.142 164.605 230.993 171.268V204.621C231.007 208.414 230.231 212.168 228.715 215.645C227.198 219.124 224.971 222.249 222.178 224.818C219.385 227.387 216.087 229.343 212.495 230.561C208.902 231.779 205.096 232.231 201.318 231.889C201.288 231.886 201.258 231.883 201.228 231.88C166.264 228.071 132.678 216.095 103.169 196.915C75.7157 179.422 52.4396 156.086 34.9919 128.565C15.794 98.8486 3.84711 65.0181 0.118008 29.8129C0.115263 29.787 0.112721 29.7611 0.110381 29.7351C-0.22945 25.965 0.217437 22.1652 1.42281 18.5772C2.62819 14.9893 4.56585 11.6914 7.11314 8.89384C9.66046 6.09624 12.7617 3.86023 16.2197 2.32889C19.6779 0.797548 23.4167 0.00465297 27.198 0.00108289L27.2027 0.00107812L60.5147 0.00108051Z"
                  fill="#999999"
                />
              </svg>
            </div>
            <div
              className="item-list"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "4px",
                textAlign: "center",
              }}
            >
              <span>
                {summaryData?.connected || 0}/<sub>300</sub>
              </span>
              <div className="item-desc" style={{ fontSize: "11px" }}>
                Connected Calls
              </div>
            </div>
            <div
              className="item-list"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "4px",
                textAlign: "center",
              }}
            >
              <span>{summaryData?.missed || 0}</span>
              <div className="item-desc" style={{ fontSize: "11px" }}>
                Incoming Calls Missed
              </div>
            </div>
            <div
              className="item-list"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "4px",
                textAlign: "center",
              }}
            >
              <span>{!!summaryData?.call_time ? summaryData?.call_time?.split(" mins")[0]?.replaceAll(" hrs,", "h ") + "m" : `----`}</span>
              <div className="item-desc" style={{ fontSize: "11px" }}>
                Call Time
              </div>
            </div>
            <div
              className="item-list"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "4px",
                textAlign: "center",
              }}
            >
              <span>{summaryData?.outgoing_missedcalls || 0}</span>
              <div className="item-desc" style={{ fontSize: "11px" }}>
                Outgoing Calls Missed
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12 col-lg-6 col-xl-6 cl-right">
          <div className="col-right listing-row">
            <div className="item-list first-icon">
              <svg width="27" height="40" viewBox="0 0 84 122" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M63.6309 56.7573L63.6301 56.7592C61.187 62.1567 57.2403 66.5131 51.8505 69.8256L63.6309 56.7573ZM63.6309 56.7573L63.6325 56.7538L63.6309 56.7573ZM51.8441 69.8296L51.8502 69.8258L65.9197 47.6112C66.0541 46.8842 66.6804 46.3447 67.4198 46.3447H77.0297C77.704 46.3447 78.2954 45.8948 78.4753 45.2449L82.1462 31.9847C82.4107 31.0292 81.692 30.0845 80.7006 30.0845H67.3237C66.5933 30.0845 65.9721 29.5576 65.8265 28.8418C65.0303 24.9268 63.7045 21.3689 61.8399 18.1761L62.2734 17.927C62.2733 17.9267 62.2731 17.9265 62.2729 17.9262C62.2524 17.8897 62.253 17.8495 62.2738 17.8125C62.2942 17.7763 62.3235 17.7603 62.3592 17.7603H77.0317C77.9269 17.7603 78.7131 17.1654 78.9564 16.3039L82.7022 3.04369C83.0628 1.76737 82.1038 0.5 80.7776 0.5H6.81395C5.91016 0.5 5.11868 1.10612 4.88309 1.97867L0.802507 17.0919C0.459304 18.3631 1.41673 19.6133 2.73337 19.6133H23.1889C28.4137 19.6133 32.4647 20.4783 35.4463 22.0913C38.4609 23.7221 40.6167 25.9644 41.9753 28.8272C42.1352 29.164 41.8928 29.5845 41.4544 29.5845H6.32804C5.42897 29.5845 4.6404 30.1844 4.40053 31.0509L0.729616 44.3111C0.376927 45.5851 1.3352 46.8447 2.65712 46.8447H41.3485C42.0552 46.8447 42.4726 47.5167 42.2119 48.0797C42.0934 48.3357 41.9693 48.5891 41.8396 48.84C40.3758 51.6191 38.1524 53.8574 35.1116 55.5532C32.176 57.1669 28.3383 58.0244 23.5111 58.0244H4.75912C3.64931 58.0244 2.75172 58.928 2.75917 60.0378L2.83514 71.3573C2.83828 71.8265 3.00633 72.2797 3.30988 72.6376L43.5675 120.098C43.9476 120.546 44.5053 120.805 45.0928 120.805H67.0809C68.1855 120.805 69.0809 119.909 69.0809 118.805V118.44C69.0809 117.968 68.9139 117.511 68.6093 117.15L34.7028 76.9783C34.1927 76.3739 34.5525 75.4077 35.3686 75.2844C41.9309 74.2925 47.4387 72.4911 51.8405 69.8318L51.8441 69.8296ZM36.0788 57.3038L36.0812 57.3025C39.4349 55.4332 41.9515 52.9216 43.6118 49.7671L43.6134 49.7639C44.1564 48.7141 44.6101 47.6255 44.9743 46.4985C45.246 45.6577 44.5984 44.8447 43.7518 44.8447H3.97156C3.31061 44.8447 2.83147 44.2149 3.00782 43.5779L6.12506 32.3177C6.245 31.8844 6.63928 31.5845 7.08881 31.5845H43.4012C44.2531 31.5845 44.8934 30.7505 44.5917 29.9147C44.351 29.2481 44.0812 28.5998 43.7822 27.9697C42.2298 24.6987 39.7616 22.1519 36.398 20.3322C33.0233 18.5066 28.6087 17.6133 23.1889 17.6133H4.03918C3.38085 17.6133 2.90214 16.9882 3.07375 16.3526L6.61433 3.23933C6.73213 2.80306 7.12787 2.5 7.57976 2.5H79.4559C80.1191 2.5 80.5986 3.13369 80.4183 3.77185L77.2374 15.0321C77.1157 15.4628 76.7227 15.7603 76.2751 15.7603H60.6329C59.7099 15.7603 59.2027 16.7931 59.6871 17.5339C59.984 17.9879 60.2686 18.452 60.5409 18.9262L60.5428 18.9294C62.4773 22.241 63.8152 25.9864 64.552 30.1712C64.6938 30.9766 65.3885 31.5845 66.2212 31.5845H79.3861C80.0471 31.5845 80.5262 32.2143 80.3499 32.8513L77.2326 44.1115C77.1127 44.5448 76.7184 44.8447 76.2689 44.8447H66.2815C65.4498 44.8447 64.7577 45.4583 64.6291 46.2661C64.0737 49.7552 63.1324 52.9775 61.8077 55.9352C59.5429 60.9386 55.8818 65.0002 50.8045 68.121C45.9775 71.0368 39.6118 72.917 31.68 73.7356C30.7784 73.8286 30.3295 74.8976 30.9229 75.6007L67.018 118.366C67.0586 118.414 67.0809 118.475 67.0809 118.538C67.0809 118.685 66.9614 118.805 66.814 118.805H45.5558C45.2621 118.805 44.9832 118.676 44.7932 118.452L5.07003 71.6208C4.91825 71.4419 4.83423 71.2153 4.83265 70.9807L4.76588 61.0311C4.76215 60.4762 5.21095 60.0244 5.76585 60.0244H23.5111C28.5616 60.0244 32.7605 59.1288 36.0788 57.3038Z"
                  fill="#999999"
                  stroke="#999999"
                />
              </svg>
            </div>
            <div
              className="item-list"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "4px",
                textAlign: "center",
              }}
            >
              <span>
                {summaryData?.ptp || 0}/<sub>50</sub>
              </span>
              <div className="item-desc" style={{ fontSize: "11px" }}>
                PTP
              </div>
            </div>
            <div
              className="item-list"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "4px",
                textAlign: "center",
              }}
            >
              <span>{summaryData?.missed_disposition || 0}</span>
              <div className="item-desc" style={{ fontSize: "11px" }}>
                Dispositions Pending
              </div>
            </div>
            <div
              className="item-list"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "4px",
                textAlign: "center",
              }}
            >
              <span className="d-flex align-items-end gap-1">
                <span className="tx-16">{`₹`}</span>
                <span>
                  {compactFormat(summaryData?.final_value || 0)}/<sub>2L</sub>
                </span>
              </span>
              <div className="item-desc" style={{ fontSize: "11px" }}>
                Total Collection
              </div>
            </div>
            <div
              className="item-list"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "4px",
                textAlign: "center",
              }}
            >
              <span className="text-center">{summaryData?.setl_count || 0}</span>
              <div className="item-desc" style={{ fontSize: "11px" }}>
                SETL Count
              </div>
            </div>

            <button
              style={{ background: "transparent", fontSize: "10px", position: "absolute", right: "5px", top: "5px" }}
              disabled={loading}
              onClick={getPanelSummary}
              className="d-flex flex-column align-items-center justify-content-center gap-2 border-0 p-2 
                        "
            >
              <IoRefresh className="tx-16 m-0" />
              {/* {loading ? "Loading..." : "Refresh"} */}
            </button>
          </div>
        </div>
        {/* <div className="col-1 p-0 d-flex align-items-center justify-content-center">
                    <button
                        style={{ background: "transparent", fontSize: "10px" }}
                        disabled={loading}
                        onClick={getPanelSummary}
                        className="d-flex flex-column align-items-center justify-content-center gap-2 border-0 p-2 w-100 h-100"
                    >
                        <IoRefresh className="tx-16 m-0" />
                        {loading ? "Loading..." : "Refresh"}
                    </button>
                </div> */}
      </div>
    </div>
  );
}

export default memo(PanelSumarry);
